/* eslint-disable no-underscore-dangle */
/* eslint-disable import/named */
/* eslint-disable no-console */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import moment from 'moment';
import { compact, uniq, last } from 'lodash';
import { setNotification } from 'utils';
import WORKFLOW from 'containers/CRM/OrderItemsContainer/OrderItemView/workflow';
import {
    loadErrorsRes,
    loadErrorsErr,
} from '../actions/errorsActions';
import {
    LOAD_ERRORS,
    TOGGLE_ERRORS_STATUS,
} from '../types/errorsTypes';
import { getErrorsApi, toggleErrorsStatusApi } from '../api/errorsApi';
import { getFormVersionsApi } from '../api/formVersionApi';
import { getAllJobResultsApi } from '../api/jobResultApi';
import { getMachinesApi } from '../api/machineApi';

const getLayout = state => state.layout;
const getErrors = state => state.errors;

// L O A D   E R R O R S
function* loadErrorsSaga() {
    const { offset, limit, filters, sort } = yield select(getErrors);

    try {
        const params = {
            limit,
            offset,
            joins: JSON.stringify(['order_item', 'job']),
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'quantity') {
                params.sort_by = JSON.stringify({ quantity: sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            } else if (sort.key === 'status') {
                params.sort_by = JSON.stringify({ status: sortInt });
            }
        }

        const sendFilters = { prepress: true };

        if (filters.formId !== '') {
            sendFilters.join = {
                'order_item.forms.form_number': {
                    operator: 'typing',
                    value: filters.formId,
                },
            };
        }

        if (filters.jobId !== '') {
            sendFilters.join = {
                'job.job_number': {
                    operator: 'typing',
                    value: filters.jobId,
                },
            };
        }

        if (filters.customer !== '') {
            sendFilters.join = {
                'order_item.customer_name': {
                    operator: 'typing',
                    value: filters.customer,
                },
            };
        }

        if (filters.machine_ids !== undefined) {
            sendFilters.machine_id = filters.machine_ids;
        }

        if (filters.size !== '') {
            sendFilters.join = {
                'order_item.configurations.configurations_property.name.value': {
                    operator: 'typing',
                    value: filters.size,
                },
            };
        }

        if (filters.carpetQuality !== '') {
            sendFilters.join = {
                'order_item.configurations.configurations_property.name.value': {
                    operator: 'typing',
                    value: filters.carpetQuality,
                },
            };
        }

        if (filters.status !== undefined) {
            sendFilters.status = filters.status;
        }

        if (filters.orderItemId !== '') {
            sendFilters.join = {
                'order_item.order_number': {
                    operator: 'typing',
                    value: filters.orderItemId,
                },
            };
        }

        if (filters.quantity !== '') {
            sendFilters.quantity = parseInt(filters.quantity, 10);
        }

        if (filters.comment !== '') {
            sendFilters.comment = {
                operator: 'typing',
                value: filters.comment,
            };
        }

        if (filters.expectedEndDate.length > 0) {
            const customDate = [
                moment.utc(filters.expectedEndDate[0]).format('YYYY-MM-DD 00:00:00'),
                moment.utc(filters.expectedEndDate[1]).format('YYYY-MM-DD 23:59:59'),
            ];
            sendFilters.expected_finish_date = { between: customDate };
        }

        params.filter = JSON.stringify(sendFilters);
        const result = yield getErrorsApi(params);

        if (result.status === 200) {
            const { hits } = result.data;

            const formVersionsIDS = uniq(compact(hits.map(hit => hit.order_item?.[0].form_versions?.[0].form_version_id)));
            const orderItemIDS = uniq(compact(hits.map(hit => hit.order_item_id)));

            const resultMachines = yield getMachinesApi({ limit: 999 });
            const machines = resultMachines.data.hits || [];

            const resultFormVersion = yield getFormVersionsApi({
                filter: JSON.stringify({ _id: formVersionsIDS }),
                joins: JSON.stringify(['rolls_outs', 'form']),
            });

            const resultJobResult = yield getAllJobResultsApi({
                filter: JSON.stringify({ order_item_id: orderItemIDS }),
                limit: orderItemIDS.length * 2,
            });

            yield put(loadErrorsRes({
                ...result.data,
                hits: hits.map((hit) => {
                    const fvID = hit.order_item[0].form_versions[0].form_version_id;
                    const formVersion = resultFormVersion.data.hits.find(fv => fv._id === fvID);

                    const [qualityConfiguration] = hit.order_item[0].configurations;

                    const quality = qualityConfiguration.configurations_property.find(cp => cp.type.toLowerCase() === 'quality');
                    const border = qualityConfiguration.configurations_property.find(cp => cp.type.toLowerCase() === 'border');

                    const workflowKey = `${border?.code !== '0' ? 'b' : ''}${quality?.code}`;

                    const steps = WORKFLOW[workflowKey];
                    const lastStep = last(steps);

                    let list = [];

                    const jobResults = resultJobResult.data?.hits || [];

                    if (lastStep?.machine_id === process.env.REACT_APP_MACHINE_COATING_IN_LINE) {
                        list = jobResults.filter(jr => jr.order_item_id === hit.order_item_id).filter(jr => (
                            !!(jr.steps_tracking || []).find(st => st.machine_id === process.env.REACT_APP_MACHINE_COATING_IN_LINE && st.state === 'DONE')
                        ));
                    } else {
                        list = (jobResults || []).filter(jr => jr.order_item_id === hit.order_item_id)
                            .filter((jr) => {
                                if (lastStep?.machine_id === process.env.REACT_APP_MACHINE_CUTTING) {
                                    return jr.parent === null;
                                }

                                return jr.parent !== null;
                            });
                    }

                    const countJr = list.reduce((acc, curr) => acc + curr.quantity, 0);

                    const count = (formVersion?.rolls_out || []).reduce((a, rollout) => {
                        const section = (rollout?.sections || []).find(s => s.form_version_id === fvID);
                        const formOrderItem = formVersion.form[0].form_order_items.find(foi => foi.order_item_id === hit.order_item_id);

                        return a + ((section?.repetition || 0) * (formOrderItem?.segment_repetition || 0));
                    }, 0);

                    return {
                        ...hit,
                        machine_name: machines.find(m => m._id === hit.machine_id)?.name || null,
                        total_pieces: countJr > 0 ? countJr : count,
                    };
                }),
            }));
        }
    } catch (e) {
        console.log(e);
        yield put(loadErrorsErr());
    }
}

export function* loadErrorsWatcher() {
    yield takeLatest(LOAD_ERRORS, loadErrorsSaga);
}
// L O A D   E R R O R S

// T O G G L E   E R R O R S   S T A T U S
function* toggleErrorsStatusSaga(action) {
    try {
        const { locale } = yield select(getLayout);
        const result = yield toggleErrorsStatusApi(action.data);
        if (result.status === 202) {
            if (action.data.status === 'FIXED') {
                setNotification('success', locale, 'global.success', 'prepress.notification.fixErrorSuccess');
            }
            if (action.data.status === 'REJECTED') {
                setNotification('success', locale, 'global.success', 'prepress.notification.rejectedErrorSuccess');
            }
            yield call(loadErrorsSaga, {});
        } else if (action.data.status === 'REJECTED') {
            setNotification('error', locale, 'global.error', 'prepress.notification.rejectedErrorError');
        } else {
            setNotification('error', locale, 'global.error', 'prepress.notification.fixErrorError');
        }
    } catch (e) {
        console.log(e);
    }
}

export function* toggleErrorsStatusWatcher() {
    yield takeLatest(TOGGLE_ERRORS_STATUS, toggleErrorsStatusSaga);
}
// T O G G L E   E R R O R S   S T A T U S
